import dynaForms from '@elab/core/utils/dynaForms';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import types, { storeName } from './types';

export const initialState = (state, initialData) => ({
    ...dynaInitialState(state),
    ...initialData,
    deliveryModes: [],
    isTimeSlotEmpty: true,
});
const dynaFormReduce = dynaForms.createReducer(storeName);

const reducers = (state = initialState(), action) => {
    state = dynaFormReduce(state, action);
    const { data } = state;
    const { payload } = action;

    switch (action.type) {
        case types.SET_DELIVERY_TIME_SLOTS:
            return {
                ...state,
                data: {
                    ...data,
                    deliveryTime: {
                        ...data.deliveryTime,
                        values: payload,
                        value: null,
                        required: true,
                    },
                },
            };

        case types.SET_DELIVERY_MODES:
            return reduceAction(state, 'deliveryModes', payload);

        case types.SET_IS_TIME_SLOT_EMPTY:
            return {
                ...state,
                isTimeSlotEmpty: payload,
                data: {
                    ...data,
                    deliveryTime: {
                        ...data.deliveryTime,
                        required: true,
                    },
                },
            };
        default:
            return state;
    }
};

export default reducers;
